const e = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      justifyContent: "flex-start",
      padding: t.spacing(1, 3, 3)
    })
  }
};
export {
  e as default
};
